export default "__VITE_ASSET__56c465c7__"